
import state from './moduleStepsManagementState'
import mutations from './moduleStepsManagementMutations'
import actions from './moduleStepsManagementActions'
import getters from './moduleStepsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

